module.exports = "body {\n  font-family: 'Open Sans','Open Sans Hebrew','Open Sans',Arial !important;\n  padding-top: 3.5rem; }\n\n.wind {\n  font-family: 'Open Sans','Open Sans Hebrew','Open Sans',Arial !important;\n  padding: 10px; }\n\nh5 {\n  margin-bottom: 2px; }\n\n.pd {\n  padding-bottom: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/blocks/infoWindow/iWindow.component.scss
// module id = ./src/app/component/blocks/infoWindow/iWindow.component.scss
// module chunks = main